import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-574fe6b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_content" }
const _hoisted_2 = { class: "mid" }

import Map from '@/components/map/Map.vue'
// import Dialog from '@/components/Dialog.vue'
import Dialog from '@/components/Dialog/Dialog.vue'
import Dialog2 from '@/components/Dialog/Dialog2.vue'
import LayersManage from '@/components/map/LayersManage.vue'
import HtHeader from '@/components/HtHeader.vue'

import VideoInfo from '@/components/map/VideoInfo.vue'
import mapService from '@/utils/mapServices'
import MapTools from '@/components/map/MapTools.vue'
import MapLegend from '@/components/map/MapLegend.vue'
import Bus from '@/config/Bus'
import { NButton } from 'naive-ui'
import { ref, reactive, nextTick, onMounted } from 'vue'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
import { useMessage } from 'naive-ui'




export default /*#__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

window.$message2 = useMessage()

const mainStore = useMainStore(pinia)
const xhData = ref({
  lxhd: '',
  userName: '',
  lxdh: '',
})
const isShowCall = ref(false)
const videoPopShow = ref(false)
const videoInfo = ref()

const showCall = (data) => {
  xhData.value = data
  isShowCall.value = true
  videoPopShow.value = false
  nextTick(() => {
    videoInfo.value.calluser()
  })
}

const hideCall = () => {
  isShowCall.value = false
}

onMounted(() => {
  Bus.on('showCall', (data) => {
    showCall(data)
  })
  mapService.on('zjClick', (data) => {
    if (mainStore.currentLeftMenu === 'river_cheif_state') {
      Bus.emit('showModal', {
        data: {
          zj: data,
        },
        modalType: '分布统计',
      })
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Map),
    _createVNode(HtHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterView)
      ]),
      _createVNode(VideoInfo, {
        ref_key: "videoInfo",
        ref: videoInfo,
        visible: isShowCall.value,
        "xh-data": xhData.value,
        onHideCall: hideCall
      }, null, 8, ["visible", "xh-data"])
    ]),
    _createVNode(MapLegend, { style: {"right":"420px"} }),
    _createVNode(MapTools, { style: {"right":"620px"} }),
    _withDirectives(_createVNode(LayersManage, null, null, 512), [
      [_vShow, _unref(mainStore).customer]
    ]),
    _createVNode(Dialog),
    _createVNode(Dialog2)
  ], 64))
}
}

})